import { Avatar, Flex, Text } from "@chakra-ui/react";
import { useUser } from "../hooks/user.hooks";

function UserAvatar({ userId, logo }: { userId: number; logo?: boolean }) {
	const { data: user } = useUser(userId);

	if (!user) {
		return <>---</>;
	}
	return (
		<Flex>
			{(logo === undefined || logo === true) && (
				<Avatar
					name={`${user.firstName} ${user.lastName}`}
					src="https://bit.ly/cbouchard"
					h="40px"
					w="40px"
					mr="10px"
				/>
			)}
			<Flex direction="column">
				<Text
					lineHeight="21px"
					fontWeight="600"
					size="14px"
					textTransform="capitalize"
				>
					{user.firstName} {user.lastName}
				</Text>
				{user.isSuperAdmin && (
					<Text lineHeight="21px" color="gray.500" textTransform={"capitalize"}>
						Supembouts
					</Text>
				)}
				{!user.isSuperAdmin && (
					<Text lineHeight="21px" color="gray.500" textTransform={"capitalize"}>
						Utilisateur
					</Text>
				)}
			</Flex>
		</Flex>
	);
}

export default UserAvatar;
